import { defineMessages } from "react-intl";

export const messages = defineMessages({
    selectedDashboardPlaceholder: {
        id: "analytics.selectedDashboardPlaceholder",
        defaultMessage: "Dashboard",
    },
});
